import { render, staticRenderFns } from "./systemConfDialog.vue?vue&type=template&id=bc14ec50&scoped=true&"
import script from "./systemConfDialog.vue?vue&type=script&lang=js&"
export * from "./systemConfDialog.vue?vue&type=script&lang=js&"
import style0 from "./systemConfDialog.vue?vue&type=style&index=0&id=bc14ec50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc14ec50",
  null
  
)

component.options.__file = "systemConfDialog.vue"
export default component.exports